export const deleteDelegation = async (client, data, params, url="/delegations") => {
    try {
        return await client.delete(url, data, params);
    } catch(err) {
        console.warn(err);
        throw err;
    }
};
